import { useFocusMode } from 'hooks/useFocusMode';
import { PropsWithChildren } from 'react';

export const FocusModeWrapper = (props: PropsWithChildren<React.ReactNode>) => {
  const { children } = props;
  const isFocusMode = useFocusMode();

  if (isFocusMode) {
    return <></>;
  }

  return <>{children}</>;
};
